export default __webpack_public_path__ + "static/media/chevron-down.1ea610cc.svg";